var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.971191,
    width: 30,
    height: 30,
    rx: 8,
    fill: "black",
    fillOpacity: 0.85
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1912 22.5V15.6578H19.6034L19.9646 12.9913H17.1911V11.2888C17.1911 10.5167 17.4162 9.99065 18.5791 9.99065L20.0622 9.98999V7.60506C19.8057 7.57262 18.9253 7.5 17.9011 7.5C15.7628 7.5 14.2988 8.74265 14.2988 11.0248V12.9913H11.8804V15.6578H14.2988V22.4999H17.1912V22.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacebook);
export default __webpack_public_path__ + "static/media/ic_facebook.0ca24aa9.svg";
export { ForwardRef as ReactComponent };